import { Stacked, Typography } from '@statsbomb/kitbag-components';
import TranslationsImage from '@/images/screenshots/translations.jpg';
import { OnboardingItemKey } from '@/types/userConfigs';
import { classicUrl } from '@/utils/classicLinks';
import { FirstTimeModal } from './FirstTimeModal';

// TODO (EPT-35279: restore i18n keys once XTM translations are ready)
export const FirstTimeModalTranslations = () => (
  <FirstTimeModal
    modalType={OnboardingItemKey.TRANSLATIONS}
    id="first-time-translations-modal"
    title="Hudl Statsbomb (new experience) now available in 10 more languages"
    confirmLabel="Go to Settings"
    onConfirmNavigate={() => {
      window.location.href = classicUrl('personalisation/my-language');
    }}
  >
    <Stacked direction="column" gap="medium">
      <div>
        <Typography variant="headingMedium">
          Every dashboard, metric and radar now works in 10 more Languages:
        </Typography>
        <Typography variant="bodyRegular">
          🇩🇪 German, 🇪🇸 Spanish, 🇵🇹 Portuguese, 🇫🇷 French, 🇮🇹 Italian, 🇯🇵 Japanese, 🇰🇷 Korean, 🇨🇳 Chinese, 🇳🇱 Dutch, 🇬🇷
          Greek.
        </Typography>
        <Typography variant="bodyRegular" as="ul">
          <Typography variant="bodyRegular" as="li">
            Switch anytime from Settings.
          </Typography>
          <Typography variant="bodyRegular" as="li">
            More languages and translation of our classic pages are on the way.
          </Typography>
        </Typography>
      </div>
      <img src={TranslationsImage} width={648} height={266} alt="Internationalization feature" />
    </Stacked>
  </FirstTimeModal>
);
